// @flow
import React from 'react';
import { escapeForUrl } from 'lib/common';
import { Link } from 'react-router-dom';
import './BannerTags.scss';

type Props = {
  tags: string[],
};

const BannerTags = ({ tags }: Props) => (
  <div className="BannerTags">
    {tags.map(t => (
      <Link to={`/tags/${escapeForUrl(t)}`} key={t}>
        {t}
      </Link>
    ))}
  </div>
);

export default BannerTags;



// WEBPACK FOOTER //
// ./src/components/banner/BannerTags/BannerTags.js